const { breakpoints, fontSizes, space, shadows, radii } = require('./common');
const ouColors = require('./ou-theme');
const lowColors = require('./low-theme');

// ---
// OU
// ---

exports.ouTheme = {
  breakpoints,
  fontSizes,
  space,
  shadows,
  radii,
  colors: ouColors,
};

// ---
// LOW
// ---

exports.lowTheme = {
  breakpoints,
  fontSizes,
  space,
  shadows,
  radii,
  colors: lowColors,
};

// ---
// Optidox
// ---

exports.optidox = {
  breakpoints,
  fontSizes,
  space,
  shadows,
};



// WEBPACK FOOTER //
// ../shared/optilit-themes/src/index.js